<template>
  <div class="feedback-page">
    <div v-for="(item, index) in feedbackList" :key="index" class="feedback-card">
      <!-- 反馈类型、状态和内容 -->
      <div class="feedback-header">
        <div class="feedback-type-info">
          <span class="feedback-label">反馈类型：</span>
          <span class="feedback-value">{{ getTypeLabel(item.type) }}</span>
        </div>
        <div :class="['feedback-status', item.status === 1 ? 'feedback-status-pending' : 'feedback-status-processed']">
          {{ item.status === 1 ? '待处理' : '已处理' }}
        </div>
      </div>

      <!-- 反馈内容 -->
      <div class="feedback-content">
        <span class="feedback-label">反馈内容：</span>
        <span class="feedback-text">{{ item.content || '-' }}</span>
      </div>

      <!-- 处理内容（仅已处理状态显示） -->
      <div v-if="item.status !== 1" class="feedback-handle-content">
        <span class="feedback-label">处理内容：</span>
        <span class="feedback-text">{{ item.handleContent || '-' }}</span>
      </div>

      <!-- 底部操作区 -->
      <div class="feedback-footer">
        <div class="feedback-channel">{{ item.categoryName || '-' }}</div>
        <div class="feedback-article" v-if="item.newCode">
          <a :href="'/zp/a/' + item.newCode" target="_blank" @click.stop="goNewsDetail(item.newCode)" class="article-link">
            {{ item.title || '-' }}
          </a>
        </div>
        <div v-else class="feedback-article">{{ item.title || '-' }}</div>
        <div class="feedback-date">{{ formatDate(item.createTime) }}</div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="feedbackList.length === 0" class="feedback-empty">
      <div class="feedback-empty-icon" />
      <div class="feedback-empty-text">暂无反馈意见</div>
    </div>

    <!-- 分页加载 -->
    <div v-if="feedbackList.length > 0" class="feedback-load-more">
      <span
        v-if="hasMore"
        class="feedback-load-btn"
        :class="{ 'is-loading': loading }"
        @click="loadMore"
      >{{ loading ? '加载中...' : '查看更多' }}</span>
      <span v-else class="feedback-load-done">已经加载完成全部数据</span>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { fetchFeedbackList } from '../../api'

export default {
  name: 'Feedback',
  data() {
    return {
      feedbackList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      hasMore: true
    }
  },
  mounted() {
    this.getFeedbackList()
  },
  methods: {
    async getFeedbackList() {
      this.loading = true
      try {
        const result = await fetchFeedbackList({ pageNum: this.pageNum, pageSize: this.pageSize })
        console.log('[Feedback] API result:', result)
        const list = result.rows || result.records || []
        console.log('[Feedback] extracted list:', list)
        
        if (this.pageNum === 1) {
          this.feedbackList = list
        } else {
          this.feedbackList = [...this.feedbackList, ...list]
        }
        
        this.total = result.total || 0
        this.hasMore = this.feedbackList.length < this.total
        console.log('[Feedback] feedbackList after update:', this.feedbackList)
        console.log('[Feedback] total:', this.total, 'hasMore:', this.hasMore)
      } catch (err) {
        console.error('[Feedback] error:', err)
        Toast(err.message || '获取反馈意见失败')
      } finally {
        this.loading = false
        this.$emit('loaded')
      }
    },
    
    loadMore() {
      if (this.loading || !this.hasMore) return
      this.pageNum++
      this.getFeedbackList()
    },
    
    goNewsDetail(newsCode) {
      // 点击链接时，使用 window.open 打开新窗口
      window.open(`/zp/a/${newsCode}`, '_blank')
    },
    
    getTypeLabel(type) {
      const typeMap = {
        1: '不实信息',
        2: '侵权相关',
        3: '栏目不宜',
        4: '内容有误',
        5: '其他'
      }
      return typeMap[type] || '未知类型'
    },
    
    formatDate(time) {
      if (!time) return '-'
      // 如果已经是格式化字符串直接返回
      if (typeof time === 'string' && time.length <= 20) return time
      try {
        const d = new Date(time)
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        const hours = String(d.getHours()).padStart(2, '0')
        const minutes = String(d.getMinutes()).padStart(2, '0')
        const seconds = String(d.getSeconds()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      } catch (e) {
        return String(time)
      }
    }
  }
}
</script>

<style scoped>
.feedback-page {
  padding: 16px;
}

.feedback-card {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.feedback-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.feedback-type-info {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.feedback-label {
  font-size: 14px;
  color: #666666;
}

.feedback-value {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}

.feedback-content {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.feedback-handle-content {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.feedback-text {
  font-size: 14px;
  color: #333333;
  flex: 1;
  line-height: 1.6;
}

.feedback-status {
  font-size: 13px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 12px;
}

.feedback-status-pending {
  color: #FF9800;
  background: #FFF3E0;
}

.feedback-status-processed {
  color: #4CAF50;
  background: #E8F5E9;
}

.feedback-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #999999;
  flex-wrap: wrap;
}

.feedback-channel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 12px;
  background: #F5F7FA;
  border-radius: 4px;
  font-size: 12px;
  color: #666666;
}

.article-link {
  color: #333333;
  cursor: pointer;
  transition: color 0.2s;
}

.article-link:hover {
  color: #C00513;
  text-decoration: underline;
}

.feedback-article {
  flex: 1;
  min-width: 0;
  font-size: 13px;
}

.feedback-date {
  flex-shrink: 0;
}

.feedback-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
}

.feedback-empty-icon {
  width: 120px;
  height: 80px;
  background: #E8E8E8;
  border-radius: 4px;
  margin-bottom: 16px;
  position: relative;
}

.feedback-empty-icon::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 32px;
  background: #D9D9D9;
  border-radius: 2px;
}

.feedback-empty-icon::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 2px;
  background: #FFFFFF;
  border-radius: 1px;
}

.feedback-empty-text {
  font-size: 14px;
  color: #999999;
}

.feedback-load-more {
  display: flex;
  justify-content: center;
  padding: 20px 0 10px;
}

.feedback-load-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 32px;
  border: 1px solid #DCDEE0;
  border-radius: 18px;
  font-size: 14px;
  color: #323233;
  cursor: pointer;
  transition: all 0.2s ease;
}

.feedback-load-btn:hover {
  color: #0084E7;
  border-color: #0084E7;
}

.feedback-load-btn.is-loading {
  color: #999999;
  cursor: default;
  border-color: #EBEDF0;
}

.feedback-load-done {
  font-size: 13px;
  color: #C8C9CC;
}
</style>
